import React from 'react';

const MenuItem = ({ item, language, onItemClick }) => {
  return (
    <div className="menu-item-row" onClick={() => onItemClick(item)}>
      <div className="item-details">
        <h3 className="item-name">{item[`${language}_name`]}</h3>
        <p className="item-price">IQD {item.price.toLocaleString()}</p>
        
      </div>
      <div className="item-image-container">
        <img
          src={item.thumb_link}
          alt={item[`${language}_name`]}
          className="item-image"
        />
      </div>
    </div>
  );
};

export default MenuItem;